import { UserRound } from "lucide-react"

type UserAvatarProps = {
  initials?: string
  size?: "nav" | "profile"
}

const UserAvatar = ({ initials, size = "nav" }: UserAvatarProps) => {
  const nav = size === "nav"
  const box = nav ? "h-9 w-9" : "h-14 w-14"
  const label = nav ? "text-[0.68rem]" : "text-[0.95rem]"
  const icon = nav ? "h-4 w-4" : "h-6 w-6"

  if (initials) {
    return (
      <span
        aria-hidden="true"
        className={[
          "inline-flex items-center justify-center overflow-hidden rounded-full font-semibold uppercase leading-none tracking-[0.08em] text-white",
          "bg-[radial-gradient(circle_at_32%_28%,#8ec0e4_0%,#3c79b4_46%,#2a5d8f_100%)]",
          "shadow-[inset_0_1px_0_rgba(255,255,255,0.55),0_1px_2px_rgba(32,64,96,0.16)]",
          "ring-1 ring-[#1e4e78]/20",
          "transition-shadow duration-200",
          "group-hover:shadow-[inset_0_1px_0_rgba(255,255,255,0.65),0_6px_14px_rgba(60,121,180,0.34)]",
          box,
          label,
        ].join(" ")}
      >
        {initials}
      </span>
    )
  }

  return (
    <span
      aria-hidden="true"
      className={[
        "inline-flex items-center justify-center rounded-full border border-[#c9dbe6] text-[#3c79b4]",
        "bg-[radial-gradient(circle_at_32%_28%,#ffffff_0%,#e7f2f8_100%)]",
        "shadow-[inset_0_0_0_3px_rgba(243,246,247,0.9)]",
        "transition-[border-color,box-shadow] duration-200",
        "group-hover:border-[#3c79b4] group-hover:shadow-[inset_0_0_0_3px_#eef5fa,0_4px_10px_rgba(60,121,180,0.16)]",
        box,
      ].join(" ")}
    >
      <UserRound className={icon} strokeWidth={1.75} />
    </span>
  )
}

export default UserAvatar
